import React, { lazy } from 'react';
// project imports
import MainLayout from '../layout/MainLayout';
import { Loadable } from '@components';
import { pages } from "../views/public-pages";

const ConfirmLogin = Loadable(lazy(() => import('../views/authentication/authentication/ConfirmLogin')));
const ForgotPasswordContainer = Loadable(lazy(() => import('../views/authentication/authentication/ForgotPasswordContainer')));
const ResetPasswordContainer = Loadable(lazy(() => import('../views/authentication/authentication/ResetPasswordContainer')));
const SignupWithAuthGroup = Loadable(lazy(() => import('../views/authentication/authentication/SignupWithAuthGroupContainer')));
const NoTenantContainer = Loadable(lazy(() => import('../views/authentication/authentication/NoTenantContainer')));

const publicPages = [];
for (const page of pages) {
    const PageControl = Loadable(lazy(() => import(`../views/public-pages/${page}`)));
    publicPages.push({
        path: `/pp/${page}`,
        element: <PageControl />
    });
}


// ==============================|| MAIN ROUTING ||============================== //

const OtherAuthenticationRoutes = () => ({
    path: '/', // TODO: if face auth error change it to /auth
    element: <MainLayout complete={false} />,
    children: [
        {
            path: '/auth/confirm-login',
            element: <ConfirmLogin />
        },
        {
            path: '/auth/reset-password',
            element: <ResetPasswordContainer />
        },
        {
            path: '/auth/forgot-password',
            element: <ForgotPasswordContainer />
        },
        {
            path: '/auth/group-signup/:groupId',
            element: <SignupWithAuthGroup />
        },
        {
            path: '/auth/no-tenant',
            element: <NoTenantContainer />
        },
        ...publicPages
    ]
});

export default OtherAuthenticationRoutes;
